<template>
  <div id="app">
      <b-button class="btn-trans" :class="'marker-'+index" v-b-modal.modal-facts  v-for="(fact, index) in this.facts" v-bind:key="index" :value="index" @click="popupContent">
        <map-pin :class="'fact-'+index" :data-popup="index"></map-pin>
      </b-button>
    
    <route-planner></route-planner>
    <div>
      <b-modal id="modal-facts" title="">
        <img class="modal-heading-image" :src="require('./assets/img/'+this.modalImage+'.png')">
        <h3 class="text-center">{{this.modalHeading}}%</h3>
        <p class="text-center">{{this.modalCopy}}</p>
      </b-modal>
      <b-modal id="modal-info" title="">
        <h3 class="text-center">What is this tool?</h3>
        <div class="text-center">
          <p>Want to be healthy and fit? We have created this map to inspire you to use alternative ways of transport.</p>
          <p>How would you like to get around the city: by walking, running, cycling or you want to grab a scooter? It's up to you!</p>
          <p>See which is faster, how many calories you would burn, and how much CO<sub>2</sub> and money you will save while keeping yourself happy and fit.</p>
        </div>
      </b-modal>
    </div>
  </div>
</template>

<script>
import RoutePlanner from './components/RoutePlanner.vue';
import MapPin from './components/MapPin.vue';
import factsJson from './assets/data/facts.json';

export default {
  name: 'App',
  components: {
    RoutePlanner,
    MapPin 
  },
    data() {
      return {
          facts: factsJson,
          modalImage: "cyclist",
          modalHeading: false,
          modalCopy: false
      }
  },
  methods : {
    popupContent: function(ev) {
      let popup = ev.target.dataset.popup;
      this.modalImage = this.facts[popup].image;
      this.modalHeading = this.facts[popup].percentage;
      this.modalCopy = this.facts[popup].copy;
    }
  },
  computed: {

  }
}
</script>
<style scoped>
#app {
  background: url('assets/img/map.png');
  background-size: contain;
  background-repeat: no-repeat;
  background-position: bottom;
  width: 100%;
  padding-bottom: 56.25vw;
  position: relative;
  
}
h1,h2 {
  text-transform: uppercase;
  font-family: "Roboto Condensed", sans-serif;
  font-size: 48px;
  line-height: 52px;
  font-weight: 600;
  font-style: italic;
  margin: 0;
}
h2 {
  color: #0071B8;
}
h3 {
  font-family: "Roboto Condensed", sans-serif;
  font-weight: 600;
  font-style: italic;
  color: #004876;
  text-transform: uppercase;
}
#modal-info h3 {
  font-size: 20px;
  margin-bottom: 16px;
}
#modal-info p {
    font-family: "Roboto Condensed", sans-serif;
    font-weight: 400;
}

#modal-facts h3 {
    font-size: 42px;
}
#modal-facts p {
    font-family: "Roboto Condensed", sans-serif;
    font-weight: 400;
    font-size: 22px;
}

.hero-heading {
  transform: rotateZ(-10deg);
  position: fixed;
  top: 48px;
  left: 25px;
}
.pin-layer {
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
}

.btn-trans {
    background-color: transparent !important;
    color: transparent !important;
    box-shadow: none !important;
    border: 0 !important;
}

.btn-info-mobile {
  position: fixed !important;
  right: 25px;
  top: 20px;
}
.info-button-label {
  position: absolute;
    top: 50%;
    transform: translate(-50%,-50%);
    font-size: 24px;
    left: 50%;
    width: 100%;
    color: white;
}
.hero-info {
  max-width: 144px;
}
.mobile-icon {
  display: none;
}

.modal-heading-image {
      position: absolute;
      width: 144px;
      top: -144px;
      left: 50%;
      transform: translateX(-50%);
      border-radius: 50%;
      border: 2px solid #004876;
}

@media(max-width: 600px) {

  h1, h2 {
    font-size: 28px;
    line-height: 28px;
  }
  .desktop-icon {
    display: none;
  }
  .btn-info-mobile {
    position: fixed;
    right: 16px;
    top: 16px;
  }
  .info-button-label {
    display: none;
  }
  .mobile-icon {
    display: block;
    width: 64px;
  }
}
@media(max-width: 442px) {
  #app {
    background-size: 160%;
    padding-bottom: 100vw;
    background-position: top;
  }
}

.btn-trans {
  position: absolute;
}
.marker-0 {
  left: 26%;
  bottom: 37%;
}
.marker-1 {
  left: 38%;
  bottom: 53%;
}
.marker-2 {
  right: 40%;
  top: 16%;
}
.marker-3 {
  right: 32%;
  top: 0;
}
.marker-4 {
  right: 32%;
  bottom: 32%;
}
@media(max-width: 442px) {
  .marker-0 {
    left: 7%;
    bottom: 39%;
  }
  .marker-3 {
    right: 16%;
  }
  .marker-4  {
    right: 16%;
  }

}


</style>

